import { render, staticRenderFns } from "./SupportPopup.vue?vue&type=template&id=6bdcf9f2&scoped=true&"
import script from "./SupportPopup.vue?vue&type=script&lang=ts&"
export * from "./SupportPopup.vue?vue&type=script&lang=ts&"
import style0 from "./SupportPopup.vue?vue&type=style&index=0&id=6bdcf9f2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bdcf9f2",
  null
  
)

export default component.exports